var captcha = {
	el: document.getElementById('customizedCaptcha'),
	validation: function(){
		var url = captcha.el.getAttribute('data-captcha-url');
		var param = {
			LBD_VCID_customizedCaptcha: $("#LBD_VCID_customizedCaptcha").val(),
			getInstanceId: $("#getInstanceId").val(),
			getCodeCollection: $("#getCodeCollection").val(),
			captchaCodeTextBox: $("#captchaCodeTextBox").val()
		};
		
		if(!url) {
			return true;
		}

		var productCategory = captcha.el.querySelector('input[name="productCategory"]');
		if(productCategory) {
			param.productCategory = productCategory.value;
		}
		
		var result = true;
		if(param.captchaCodeTextBox != '' && param.captchaCodeTextBox) {
			$.ajax({
				type: 'post',
				url: url,
				async: false,
				dataType: 'json',
				data: param,
				success: function(data) {
					if(data.result == false) {
						$(captcha.el).find('.field-block').addClass('error');
						$(captcha.el).find('.error-msg .ajax-msg').text(data.error.captchaCodeTextBox).show().siblings().hide();
						$(captcha.el).find('.LBD_ReloadLink').trigger('click');
						result = data.result;
					}else if(data.result != false) {
						$(captcha.el).find('.field-block').removeClass('error');
						result = data;
					}
				
				},
				error: function(request,status,error) {
					console.log("status: "+status);
					console.log("error: "+error);
					result = false;
				}
			});
			
		}else {
			$(captcha.el).find('.field-block').addClass('error');
			$(captcha.el).find('.error-msg .required').show().siblings().hide();
			result = false;
		}

		return result;
	},
	addEvent: function(){
		$(captcha.el).on({
			keydown: function(e){
				if(e.keyCode==13) {
					if(!captcha.validation()) {
						return false;
					}
				}
			}
		}, 'input');
	}
};


$(document).ready(function(){
	if(!document.getElementById('customizedCaptcha')) return false;

	// captcha initiated;
	BotDetect.Init(
		captchaInit[0],
		captchaInit[1],
		captchaInit[2],
		captchaInit[3],
		captchaInit[4],
		captchaInit[5],
		captchaInit[6],
		captchaInit[7],
		captchaInit[8],
		captchaInit[9]
	);
	function customizedCaptcha_SoundIcon_onclick(){	customizedCaptcha.PlaySound();}
	// captcha initiated;
	captcha.addEvent();
});